import {
  Typography,
  Box,
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
} from "@mui/material";
import CtBtn from "../CustomTool/CtBtn";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowForward, ContactSupport } from "@mui/icons-material";

const faqs = [
  {
    q: "Is the app GST/e-Invoice compatible?",
    a: "Yes — the app supports GST reporting and integrates with e-Invoice and e-Way generation modules.",
  },
  {
    q: "Can I use multi-users & roles?",
    a: "Yes — role-based access control for admins, accountants, sales & more.",
  },
  {
    q: "Do you provide backups & cloud storage?",
    a: "We provide secure cloud backups and options to export data (CSV/Excel/PDF).",
  },
];

function Faq() {
  return (
    <div style={{ padding: "30px 0px", backgroundColor: "#f6f9ffff" }}>
      <Box textAlign="center" sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            mb: 2,
            color: "primary.main",
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 600, mx: "auto" }}
        >
          Find answers to common questions about AccoMate
        </Typography>
      </Box>

      <Grid
        container
        spacing={2}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Grid item xs={12} md={6}>
          {faqs.map((f, idx) => (
            <Accordion
              key={idx}
              elevation={0}
              sx={{
                mb: 2,
                borderRadius: "8px !important",
                border: "1px solid",
                borderColor: "divider",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  fontWeight: 600,
                  "&:hover": { backgroundColor: "action.hover" },
                }}
              >
                <Typography sx={{ fontWeight: 600 }}>{f.q}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography color="text.secondary">{f.a}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper
            sx={{
              borderRadius: 2,
              backgroundColor: "#1976d2",
              color: "primary.contrastText",
              // height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              padding: "20px 20px",
            }}
          >
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                Need custom features?
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mb: 1 }}>
                We offer tailored plans and onboarding for businesses of all
                sizes.
              </Typography>
            </Box>
            <CtBtn
              variant="contained"
              size="large"
              bgColor="#0cdc5f"
              sx={{
                borderRadius: 2,
                fontWeight: 600,
                color: "#ffffff",
                "&:hover": {
                  opacity: 0.9,
                },
              }}
              onClick={() => {
                const adminNumber = "918000516051";
                const message =
                  "Hello, I’m interested in your tailored plans and custom features. Can I connect with your sales team?";
                const url = `https://wa.me/${adminNumber}?text=${encodeURIComponent(
                  message
                )}`;

                window.open(url, "_blank");
              }}
              label="Contact Sales"
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default Faq;
